// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"158":"5d173a10","782":"5a34a2f9"}[chunkId] + ".chunk.js";
};